/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientHub_client_hub_read } from '../models/ClientHub_client_hub_read';
import type { ClientHub_client_hub_write } from '../models/ClientHub_client_hub_write';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClientHubService {
    /**
     * Retrieves the collection of ClientHub resources.
     * Retrieves the collection of ClientHub resources.
     * @param page The collection page number
     * @returns ClientHub_client_hub_read ClientHub collection
     * @throws ApiError
     */
    public static apiV1ClientHubsGetCollection(
        page: number = 1,
    ): CancelablePromise<Array<ClientHub_client_hub_read>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/client_hubs',
            query: {
                'page': page,
            },
            errors: {
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates a ClientHub resource.
     * Creates a ClientHub resource.
     * @param requestBody The new ClientHub resource
     * @returns ClientHub_client_hub_read ClientHub resource created
     * @throws ApiError
     */
    public static apiV1ClientHubsPost(
        requestBody: ClientHub_client_hub_write,
    ): CancelablePromise<ClientHub_client_hub_read> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/client_hubs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input`,
                403: `Forbidden`,
                422: `Unprocessable entity`,
            },
        });
    }
    /**
     * Retrieves a ClientHub resource.
     * Retrieves a ClientHub resource.
     * @param id ClientHub identifier
     * @returns ClientHub_client_hub_read ClientHub resource
     * @throws ApiError
     */
    public static apiV1ClientHubsIdGet(
        id: string,
    ): CancelablePromise<ClientHub_client_hub_read> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/client_hubs/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Removes the ClientHub resource.
     * Removes the ClientHub resource.
     * @param id ClientHub identifier
     * @returns void
     * @throws ApiError
     */
    public static apiV1ClientHubsIdDelete(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/client_hubs/{id}',
            path: {
                'id': id,
            },
            errors: {
                403: `Forbidden`,
                404: `Resource not found`,
            },
        });
    }
}
